import { GET } from "../../APiHelper/API";


export const getTeamDetails = (team_id, onSuccess, onError) => {
    GET(`/api/v1/leagues/team/${team_id}`, onSuccess, onError)
}